import api from './apiService';
import { API_PATHS } from '../constants/portalApiPath';

const employeeService = {
  getList: (data) => api.post(API_PATHS.STAFF_LIST, data),
  getLoginOverview: (data) => api.post(API_PATHS.STAFF_LOGIN_OVERVIEW, data),
  // Member management (own clinic)
  getMemberPermissions: (userId) => api.post(API_PATHS.STAFF_MEMBER_PERMISSIONS, { user_id: userId }),
  resetMemberPassword: (userId, newPassword) => api.post(API_PATHS.STAFF_MEMBER_PASSWORD, { user_id: userId, new_password: newPassword }),
  updateMemberEmail: (userId, email) => api.post(API_PATHS.STAFF_MEMBER_EMAIL, { user_id: userId, email }),
  toggleMemberActive: (userId, isActive, effectiveDate) => api.post(API_PATHS.STAFF_MEMBER_STATUS, { user_id: userId, is_active: isActive, ...(effectiveDate ? { effective_date: effectiveDate } : {}) }),
  deleteMember: (userId) => api.post(API_PATHS.STAFF_MEMBER_DELETE, { user_id: userId }),
  getMemberUpcomingSessions: (userId, fromDate) => api.post(API_PATHS.STAFF_MEMBER_UPCOMING_SESSIONS, { user_id: userId, ...(fromDate ? { from_date: fromDate } : {}) }),
  reassignMemberSessions: (userId, assignments, fromDate) => api.post(API_PATHS.STAFF_MEMBER_REASSIGN_SESSIONS, { user_id: userId, assignments, from_date: fromDate }),
  getDetails: (data) => api.post(API_PATHS.STAFF_DETAILS, data),
  add: (formData) => api.upload(API_PATHS.STAFF_ADD, formData),
  updateProfileImage: (formData) => api.upload(API_PATHS.STAFF_UPDATE_PROFILE_IMAGE, formData),
  addSalary: (data) => api.post(API_PATHS.STAFF_ADD_SALARY, data),
  getSalaryList: (data) => api.post(API_PATHS.STAFF_SALARY_LIST, data),
  getAttendanceList: (data) => api.post(API_PATHS.STAFF_ATTENDANCE_LIST, data),
  getSessionList: (data) => api.post(API_PATHS.STAFF_SESSION, data),
  getActivitySummary: (data) => api.post(API_PATHS.STAFF_ACTIVITY_SUMMARY, data),
  getAttendanceSummary: (data) => api.post(API_PATHS.STAFF_ATTENDANCE_SUMMARY, data),
  markAttendance: (data) => api.post(API_PATHS.STAFF_ATTENDANCE, data),
  unmarkAttendance: (data) => api.post(API_PATHS.STAFF_ATTENDANCE_UNMARK, data),
  approveAttendanceRequest: (requestId) => api.post(API_PATHS.STAFF_ATTENDANCE_REQUEST_APPROVE, { requestId }),
  rejectAttendanceRequest: (requestId) => api.post(API_PATHS.STAFF_ATTENDANCE_REQUEST_REJECT, { requestId }),
  getSessionRates: (data) => api.post(API_PATHS.MEMBER_SESSION_RATES_LIST, data),
  getSessionPricing: (data) => api.post('/admin/staff/session-pricing', data),
  saveSessionRates: (data) => api.post(API_PATHS.MEMBER_SESSION_RATES_SAVE, data),
  updateSessionRate: (data) => api.post(API_PATHS.MEMBER_SESSION_RATES_UPDATE, data),
  deleteSessionRate: (data) => api.post(API_PATHS.MEMBER_SESSION_RATES_DELETE, data),
  getServiceOverrides: (data) => api.post(API_PATHS.MEMBER_SERVICE_OVERRIDES_LIST, data),
  saveServiceOverride: (data) => api.post(API_PATHS.MEMBER_SERVICE_OVERRIDES_SAVE, data),
  assignServices: (data) => api.post(API_PATHS.MEMBER_SERVICE_OVERRIDES_ASSIGN, data),
  getServiceOverridePeers: (data) => api.post(API_PATHS.MEMBER_SERVICE_OVERRIDES_PEERS, data),

  // CSV Attendance Import
  importAttendanceCSV: (formData) => api.upload(API_PATHS.ATTENDANCE_IMPORT_CSV, formData),
  previewAttendanceCSV: (formData) => api.upload(API_PATHS.ATTENDANCE_PREVIEW_CSV, formData),
  downloadAttendanceTemplate: () => api.get(API_PATHS.ATTENDANCE_DOWNLOAD_TEMPLATE),
};

export default employeeService;
